/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { login } from "../../reducers/session";
// import HomeTabs from "components/Home/HomeTabs";
import HomeMain from "components/Home/HomeMain";

function LoginContainer(props) {


  return (
    <Fragment>
      <Fragment>
        {/* <HomeTabs /> */}
        <HomeMain />
      </Fragment>
    </Fragment>
  );
}
const mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ login }, dispatch),
  };
};
const ConnectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);
export default ConnectedComponent;
